define("analytics-resources/utils/charts/create-missing-data-bands", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createMissingDataBands = createMissingDataBands;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f
  function createMissingDataBands(graphData) {
    const bands = [];
    let foundBand = false;
    let tempBand = {};
    if (!graphData || (0, _utils.isEmpty)(graphData)) {
      return undefined;
    }
    const sortedData = graphData.sort((a, b) => a[0] - b[0]);
    for (let index = 1; index < sortedData.length; index++) {
      const point = sortedData[index];
      const prevPoint = sortedData[index - 1];
      const isOnLastPoint = index === sortedData.length - 1;
      const shouldStartBand = !point[1] && point[1] !== 0 && !foundBand;
      const shouldEndBand = (point[1] || point[1] === 0) && foundBand;
      const bandEndsGraph = isOnLastPoint && foundBand;
      if (shouldStartBand) {
        tempBand.from = prevPoint[0];
        foundBand = true;
      } else if (shouldEndBand) {
        tempBand.to = point[0];
        bands.push(tempBand);
        foundBand = false;
        tempBand = {};
      } else if (bandEndsGraph) {
        tempBand.to = point[0];
        bands.push(tempBand);
      }
    }
    return bands;
  }
});